module.exports = __webpack_public_path__ + "static/media/SP_04.38981363.svg";